import Rest from '@/services/Rest';

/**
 * @typedef {SalePublicService}
 */
export default class SalePublicService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sale-checkout'
}